import QRCode from 'qrcode'

/**
 * 是否是AI发行首页
 * @returns {boolean}
 */
export function isAIHomePage(pathname) {
  return pathname.includes('/ai_publish')
}

/**
 * 根据字符串生成二维码链接
 * @param {string} str
 */
export async function generateQRCode(str) {
  return QRCode.toDataURL(str)
}
